import {
  ADD_TO_SCHEDULE,
  ADD_TO_SCHEDULE_ERROR,
  ADD_TO_SCHEDULE_SUCCESS,
  CANCEL_VISIT,
  CANCEL_VISIT_ERROR,
  CANCEL_VISIT_SUCCESS,
  DELETE_CALENDAR_EVENT,
  DELETE_CALENDAR_EVENT_ERROR,
  DELETE_CALENDAR_EVENT_SUCCESS,
  EDIT_SCHEDULE,
  EDIT_SCHEDULE_ERROR,
  EDIT_SCHEDULE_SUCCESS,
  GET_APPOINTMENT,
  GET_APPOINTMENT_ERROR,
  GET_APPOINTMENT_SUCCESS,
  GET_CURRENT_SCHEDULE,
  GET_CURRENT_SCHEDULE_ERROR,
  GET_CURRENT_SCHEDULE_SUCCESS,
  GET_PATIENT,
  GET_PATIENT_ERROR,
  GET_PATIENT_SUCCESS,
  GET_SCHEDULE_BY_ID,
  GET_SCHEDULE_BY_ID_ERROR,
  GET_SCHEDULE_BY_ID_SUCCESS,
  RESET_SCHEDULE_RECURRING_INFO,
  SET_ERROR,
  SET_IS_APPOINTMENT_POPUP_SHOWN,
  SET_IS_DELETE_CALENDAR_EVENT_SUCCESS,
  SET_IS_SUCCESS_SCHEDULE_EDIT,
  SET_LOADING,
  SET_CALENDAR_RANGE_BEFORE_NEW_VISIT,
  apiErrorCodes,
  text,
  SET_CALENDAR_OFFSET_BEFORE_NEW_VISIT,
  GET_VISIT_TYPE_GROUPS,
  GET_VISIT_TYPE_GROUPS_SUCCESS,
  GET_VISIT_TYPE_GROUPS_ERROR,
} from './CalendarConstants'
import { isString } from '@quickmd-llc/frontend-utils'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import { GET_MEMBER_SUCCESS } from '../member/MemberConstants'

const OVERLAP_CONFLICT_STATUS = 409

type OverlappingScheduleConflict = {
  type: typeof ADD_TO_SCHEDULE_ERROR | typeof EDIT_SCHEDULE_ERROR
  payload: { status: typeof OVERLAP_CONFLICT_STATUS }
}

// The API rejects overlapping schedule blocks with a bare 409 and no body ErrorCode, so the
// HTTP status is the only signal. Scoped to the add/edit actions because many unrelated
// *_ERROR actions share the same reducer case block.
const isOverlappingScheduleConflict = (value: unknown): value is OverlappingScheduleConflict => {
  if (typeof value !== 'object' || value === null) return false
  if (!('type' in value) || (value.type !== ADD_TO_SCHEDULE_ERROR && value.type !== EDIT_SCHEDULE_ERROR)) return false
  if (!('payload' in value) || typeof value.payload !== 'object' || value.payload === null) return false
  return 'status' in value.payload && value.payload.status === OVERLAP_CONFLICT_STATUS
}

const readExtraData = (value: unknown): string =>
  typeof value === 'object' && value !== null && 'extraData' in value && isString(value.extraData) ?
    value.extraData
  : ''

const initialState = {
  loading: false,
  error: '',
  schedule: [],
  pnbSchedule: [],
  visitsSchedule: [],
  visitTypeGroups: [],
  addToScheduleSuccess: false,
  deleteCalendarEventSuccess: false,
  scheduleInfoFrom: '',
  scheduleInfoTo: '',
  defaultServerErrorMessage: '',
  AppointmentInfo: {},
  isAppointmentPopUpInfoVisible: false,
  editScheduleSuccess: false,
  scheduleInfoRecurring: null,
  scheduleInfoTreatmentCenter: null,
  calendarRangeBeforeNewVisit: null,
  calendarOffsetBeforeNewVisit: null,
}

export default function calendarPageReducer(state = initialState, action = {}) {
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  switch (action.type) {
    case ADD_TO_SCHEDULE:
    case EDIT_SCHEDULE:
    case DELETE_CALENDAR_EVENT:
    case GET_CURRENT_SCHEDULE:
    case GET_SCHEDULE_BY_ID:
    case GET_APPOINTMENT:
    case GET_PATIENT:
    case CANCEL_VISIT:
    case GET_VISIT_TYPE_GROUPS:
      return {
        ...state,
        loading: true,
        addToScheduleSuccess: false,
      }
    case ADD_TO_SCHEDULE_SUCCESS:
      return {
        ...state,
        addToScheduleSuccess: true,
      }
    case SET_IS_SUCCESS_SCHEDULE_EDIT:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        editScheduleSuccess: action.payload,
      }
    case CANCEL_VISIT_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case SET_IS_DELETE_CALENDAR_EVENT_SUCCESS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        deleteCalendarEventSuccess: action.payload,
      }
    case SET_CALENDAR_RANGE_BEFORE_NEW_VISIT:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        calendarRangeBeforeNewVisit: action.payload,
      }
    case SET_CALENDAR_OFFSET_BEFORE_NEW_VISIT:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        calendarOffsetBeforeNewVisit: action.payload,
      }
    case EDIT_SCHEDULE_SUCCESS:
      return {
        ...state,
        addToScheduleSuccess: true,
      }
    case DELETE_CALENDAR_EVENT_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteCalendarEventSuccess: true,
      }
    case SET_LOADING:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        loading: action.payload,
      }
    case RESET_SCHEDULE_RECURRING_INFO:
      return {
        ...state,
        scheduleInfoRecurring: null,
        scheduleInfoTreatmentCenter: null,
      }

    case GET_VISIT_TYPE_GROUPS_SUCCESS:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const visitTypeGroups = { ...state.visitTypeGroups, [action.extraData]: action.payload }

      return {
        ...state,
        visitTypeGroups,
        loading: false,
      }

    case GET_CURRENT_SCHEDULE_SUCCESS:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const schedule = { ...state.schedule, [action.extraData]: [...action.payload.Availability] }
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const pnbSchedule = { ...state.pnbSchedule, [action.extraData]: [...action.payload.Unavailability] }
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const visitsSchedule = { ...state.visitsSchedule, [action.extraData]: [...action.payload.Visits] }

      return {
        ...state,
        loading: false,
        schedule,
        pnbSchedule,
        visitsSchedule,
      }
    case SET_IS_APPOINTMENT_POPUP_SHOWN:
      return {
        ...state,
        isAppointmentPopUpInfoVisible: {
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          ...state.isAppointmentPopUpInfoVisible,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData]: action.payload,
        },
      }
    case GET_APPOINTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        AppointmentInfo: {
          ...state.AppointmentInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData]: { ...action.payload },
        },
      }
    case GET_PATIENT_SUCCESS:
      return {
        ...state,
        isAppointmentPopUpInfoVisible: {
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          ...state.isAppointmentPopUpInfoVisible,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.visitId]: true,
        },
        loading: false,
        AppointmentInfo: {
          ...state.AppointmentInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.visitId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.AppointmentInfo[action.extraData.visitId],
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            Patient: { PatientId: state.AppointmentInfo.PatientId, ...action.payload },
          },
        },
      }
    case GET_MEMBER_SUCCESS:
      return {
        ...state,
        isAppointmentPopUpInfoVisible: {
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          ...state.isAppointmentPopUpInfoVisible,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.visitId]: true,
        },
        loading: false,
        AppointmentInfo: {
          ...state.AppointmentInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.visitId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.AppointmentInfo[action.extraData.visitId],
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            Provider: { ...action.payload },
          },
        },
      }
    case GET_SCHEDULE_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        scheduleInfoFrom: action.payload.FromDateTime,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        scheduleInfoTo: action.payload.ToDateTime,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        scheduleInfoRecurring: action.payload.RecurringSettings,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        scheduleInfoTreatmentCenter: action.payload.TreatmentCenter ?? null,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        recurringBaseTimeZone: action.payload.TimeZone,
      }

    case SET_ERROR:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.payload.UserFriendlyErrorCode) {
        return {
          ...state,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          error: getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode, '', action.payload.extra),
          defaultServerErrorMessage: '',
        }
      }
      return {
        ...state,
        error: '',
        defaultServerErrorMessage: '',
      }
    case ADD_TO_SCHEDULE_ERROR:
    case GET_SCHEDULE_BY_ID_ERROR:
    case EDIT_SCHEDULE_ERROR:
    case DELETE_CALENDAR_EVENT_ERROR:
    case GET_APPOINTMENT_ERROR:
    case GET_CURRENT_SCHEDULE_ERROR:
    case CANCEL_VISIT_ERROR:
    case GET_PATIENT_ERROR:
    case GET_VISIT_TYPE_GROUPS_ERROR: {
      let message = ''
      let defaultServerErrorMessage = ''
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.payload.UserFriendlyErrorCode || action.payload.UserFriendlyErrorCode === '') {
        message =
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.payload.UserFriendlyErrorCode ?
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode, null, action.payload.extra)
          : ''
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        defaultServerErrorMessage = action.payload.UserFriendlyErrorCode ? action.payload : ''
      } else if (isOverlappingScheduleConflict(action)) {
        message = getUserFriendlyErrorMessage(
          errorCodes.OVERLAPPING_SCHEDULE,
          undefined,
          readExtraData(action) === 'availability' ? 'availability' : 'prevent new booking',
        )
      } else {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        switch (action.payload.ErrorCode) {
          case 'PeriodNotValid':
            message = getUserFriendlyErrorMessage(errorCodes.REPEAT_TIME_AFTER_END)
            break
          case 'TypeNotValid':
            message = getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, 'schedule type')
            break
          case 'ScheduleRecurringWeekDaysNotValid':
            message = getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, 'weekday selected')
            break
          case 'ScheduleRecurringFrequencyNotValid':
            message = getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, 'frequency type')
            break
          case 'StateCodeNotValid':
            message = getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, 'state code')
            break
          case 'TimeZoneNotValid':
            message = getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, 'Timezone')
            break
          case 'ScheduleRecurringTypeNotValid':
            message = getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, 'recurring type')
            break
          case 'OccurrenceNotFound':
            message = getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, 'schedule')
            break
          case 'PeriodOverlap':
            message = getUserFriendlyErrorMessage(
              errorCodes.OVERLAPPING_SCHEDULE,
              null,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              action.extraData === 'availability' ? 'availability' : 'prevent new booking',
            )
            break
          case apiErrorCodes.PROVIDER_NOT_FOUND:
            message = getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, text.PROVIDER)
            break
          case apiErrorCodes.VISIT_NOT_FOUND:
            message = getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, text.VISIT)
            break
          case apiErrorCodes.FORBIDDEN:
            message = getUserFriendlyErrorMessage(errorCodes.CANNOT_CANCEL_VISIT)
            break
          case 'InternalServerError':
            message = getUserFriendlyErrorMessage(errorCodes.DEFAULT)
            break
          default:
            message = getUserFriendlyErrorMessage(errorCodes.DEFAULT)
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            defaultServerErrorMessage = action.payload
            break
        }
      }
      return {
        ...state,
        error: message,
        loading: false,
        defaultServerErrorMessage: defaultServerErrorMessage || '',
      }
    }
    default: {
      return state
    }
  }
}
